import { render, staticRenderFns } from "./personalNotes.vue?vue&type=template&id=2fd8deb6&"
import script from "./personalNotes.vue?vue&type=script&lang=js&"
export * from "./personalNotes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports